import { useRef, useState } from 'react'

import { DSAccordion, DSCol, DSRow, DSTag, DSText } from '@vr/ds-react'

import { OperatorUnitsProps } from './interface'
import { UnitsList } from '@/compositions/units-list'
import { STATUS_LOGISTICS } from '@/constants/status-logistics'

export const OperatorUnits = ({ data }: OperatorUnitsProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [openCount, setOpenCount] = useState(0)
  const contentRef = useRef<HTMLDivElement>(null)

  const handleClick = () => {
    const willOpen = !isOpen
    setIsOpen(willOpen)
    if (willOpen) {
      setOpenCount(prev => prev + 1)
    }
  }

  const variant = STATUS_LOGISTICS[data.situacao] ?? { style: 'outlined', label: '-' }

  return (
    <div
      onClick={handleClick}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick() }}
      role="button"
      tabIndex={0}
    >
      <DSAccordion
        defaultOpen={false}
        css={{
          marginTop: '16px',
          padding: '20px',
          border: '1px solid $ds-colors$neutralMedium',
          borderColor:
            data.situacao === 'recusado' && '$ds-colors$errorVeryDark',
          borderRadius: '8px'
        }}
      >
        <DSAccordion.Header>
          <DSRow wrap='wrap'>
            <DSCol
              xs={6}
              lg={6}
              gap={1}
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <DSText as='p'>Operadora</DSText>
              <DSText as='strong' weight='bold'>
                {data.nomeOperadora}
              </DSText>
            </DSCol>
            <DSCol
              xs={3}
              lg={2}
              gap={1}
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <DSText as='p'>Data da liberação</DSText>
              <DSText as='strong' weight='bold'>
                {data.dataLiberacao}
              </DSText>
            </DSCol>
            <DSCol
              xs={3}
              lg={2}
              gap={1}
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <DSText as='p'>Status da logística</DSText>
              <DSTag variant={variant.style}>{variant.label}</DSTag>
            </DSCol>
          </DSRow>
        </DSAccordion.Header>
        <DSAccordion.Content>
          <div
            ref={contentRef}
            role="presentation"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            {isOpen && <UnitsList key={openCount} operator={data} />}
          </div>
        </DSAccordion.Content>
      </DSAccordion>
    </div>
  )
}
